/* tslint:disable */
/* eslint-disable */
/**
 * Your Project API
 * Your project description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectCategory
 */
export interface ProjectCategory {
    /**
     * 
     * @type {number}
     * @memberof ProjectCategory
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof ProjectCategory
     */
    readonly name: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectCategory
     */
    readonly description: string;
}

export function ProjectCategoryFromJSON(json: any): ProjectCategory {
    return ProjectCategoryFromJSONTyped(json, false);
}

export function ProjectCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
    };
}

export function ProjectCategoryToJSON(value?: ProjectCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

